import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "source" }
const _hoisted_2 = {
  key: 2,
  class: "name ellipsis"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_FavIcon = _resolveComponent("FavIcon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.icon)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          icon: $props.icon,
          width: $props.size,
          height: $props.size,
          stroke: $props.stroke,
          "stroke-width": $props.strokeWidth
        }, null, 8 /* PROPS */, ["icon", "width", "height", "stroke", "stroke-width"]))
      : ($props.logo_url)
        ? (_openBlock(), _createBlock(_component_FavIcon, {
            key: 1,
            src: $props.logo_url,
            size: $props.size,
            "failed-icon": false
          }, null, 8 /* PROPS */, ["src", "size"]))
        : _createCommentVNode("v-if", true),
    ($props.name)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($props.name), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}